<template>
  <div class="operation-report-show-body-form flex flex-col">
    <div class="form-title aisea-text-18-700-dark-gray" v-if="hasFormTitle">
      {{ formTitle }}
    </div>
    <operation-divider />
    <div class="form-items grid">
      <div
        v-for="formItemProp in formItemProps"
        :key="formItemProp.key"
        class="operation-report-show-body-form-item-wrapper"
        :class="`form-item-wrapper-${formItemProp.key}`"
      >
        <form-item-image
          v-if="formItemProp.isSingleImageFile"
          :reportId="reportId"
          v-bind="formItemProp"
        />
        <operation-report-show-body-form-item v-else v-bind="formItemProp" />
        <operation-divider v-show="!isEditing" />
      </div>
    </div>
  </div>
</template>

<script>
import isString from "lodash/isString";
import mapKeys from "lodash/mapKeys";

import enterpriseFormService from "@/services/enterprises/enterpriseFormService";

import OperationReportShowBodyFormItem from "./FormItem";
import FormItemImage from "./FormItemImage";
import OperationDivider from "@/views/enterprise/addon/operation/components/OperationDivider";

export default {
  name: "OperationReportShowBodyForm",
  components: {
    OperationReportShowBodyFormItem,
    FormItemImage,
    OperationDivider,
  },
  props: {
    reportId: {
      type: String,
      required: true,
    },
    // タイトル表示に使用
    operationWorkflowForm: {
      type: Object,
      default: () => ({}),
    },
    // 権限の判定に使用
    enterpriseForm: {
      type: Object,
      default: () => ({}),
    },
    // 権限の判定に使用
    enterpriseFormVersion: {
      type: Object,
      default: () => ({}),
    },
    // 表示用データ
    reportFormVersion: {
      type: Object,
      default: () => ({}),
    },
    // 編集権限があるかどうか
    updatable: {
      type: Boolean,
      default: false,
    },
    // 編集中かどうか
    isEditing: {
      type: Boolean,
      default: false,
    },
    formVersionSortOrder: {
      type: Number,
      require: true,
    },
  },

  computed: {
    formTitle() {
      if (!isString(this.operationWorkflowForm.name)) return "";
      return this.operationWorkflowForm.name; // string
    },
    hasFormTitle() {
      return this.formTitle.length > 0;
    },
    enterpriseFormId() {
      if (!isString(this.enterpriseForm.id)) return "";
      return this.enterpriseForm.id; // string
    },
    enterpriseFormVersionId() {
      if (!isString(this.enterpriseFormVersion.id)) return "";
      return this.enterpriseFormVersion.id; // string
    },
    enterpriseFormVersionItems() {
      return this.enterpriseFormVersion.form_version_items;
    },
    reportFormVersionItemMapByFormVersionItemId() {
      const reportFormVersionItems = this.reportFormVersion
        .ao_enterprise_vessel_report_form_version_items;
      return mapKeys(reportFormVersionItems, "form_version_item_id");
    },

    // フォーム表示用データ
    formItemProps() {
      const {
        enterpriseFormId,
        enterpriseFormVersionId,
        isEditing,
        updatable,
        reportFormVersion,
        reportFormVersionItemMapByFormVersionItemId,
        formVersionSortOrder,
      } = this;
      return this.enterpriseFormVersionItems.map(enterpriseFormVersionItem => {
        const formVersionItemId = enterpriseFormVersionItem.id;
        const reportFormVersionItem =
          reportFormVersionItemMapByFormVersionItemId[formVersionItemId] || {}; // reportFormVersionItem が undefined の場合にランタイムエラーになるのを防ぐ
        const reportFormVersionItemId = reportFormVersionItem.id;
        const key = `${enterpriseFormId}-${enterpriseFormVersionId}-${reportFormVersion}-${formVersionItemId}-${reportFormVersionItemId}`;
        const isSingleImageFile = enterpriseFormService.isSingleImageFile(
          enterpriseFormVersionItem
        );
        return {
          key,
          enterpriseFormVersionItem,
          reportFormVersion,
          reportFormVersionItem,
          isEditing,
          updatable,
          isSingleImageFile,
          formVersionSortOrder,
        };
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.operation-report-show-body-form {
  row-gap: 15px;

  .form-title {
    height: 32px;
  }

  .form-items {
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 50px;
    row-gap: 0px;
  }
}
</style>
